import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "./ui/Button";
import { LogIn, X } from "lucide-react";

const GuestBanner: React.FC = () => {
  const { isGuest } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  if (!isGuest || dismissed) {
    return null;
  }

  return (
    <div
      className="bg-primary-600 text-white px-4 py-3 print:hidden"
      role="alert"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-sm">
          <LogIn className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
          <span>
            You're using a guest session.{" "}
            <strong>Create an account to save your plans.</strong>
          </span>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <Link to="/register">
            <Button
              size="sm"
              variant="outline"
              className="border-white text-white hover:bg-white/10"
            >
              Sign Up
            </Button>
          </Link>
          <button
            type="button"
            onClick={() => setDismissed(true)}
            className="p-1 hover:bg-white/10 rounded"
            aria-label="Dismiss banner"
          >
            <X className="h-4 w-4" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuestBanner;
